// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"c39ba2c4","331":"fb781044","485":"c39ba2c4","549":"c39ba2c4","884":"c39ba2c4"}[chunkId] + ".chunk.css";
};